import { twMerge } from "tailwind-merge";
import clsx, { type ClassValue } from "clsx";

/**
 * Combines Tailwind CSS classes intelligently.
 *
 * - `clsx` handles conditional logic (e.g., isActive && "bg-blue-500")
 * - `twMerge` removes conflicting Tailwind classes (e.g., p-4 vs p-6)
 *
 * Example:
 * cn("p-4 bg-red-500", isPrimary && "bg-blue-500", className)
 * -> "p-4 bg-blue-500"
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
